module.exports = __webpack_public_path__ + "toBride2-we-y-g.c9ca11a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-y-g.jpg
// module id = ZJbb
// module chunks = 0